import React, { Component } from 'react';

import AirSlider from '../../../../../../common/components/AirSlider';

import { inject, observer } from 'mobx-react';

import isFunction from 'lodash/isFunction';

import './RegistrationYearFilter.css';

@inject('translationsStore', 'carsStore')
@observer
export default class RegistrationYearFilter extends Component {
  constructor(props) {
    super(props);

    this.state = { visible: this.props.visible };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.status !== this.props.status && this.props.status === false) {
      this.reset();
    }
  }

  reset = () => {
    if (isFunction(this.props.reset)) {
      this.props.apply();
    }
    if (this.props.reset !== false) {
      this.setState({
        registrationYear: null
      });
    }
  };

  changeRegistrationYear = registrationYear => {
    this.setState({ registrationYear });
    this.props.carsStore.appliedFilters.registrationYearMin = registrationYear[0];
    this.props.carsStore.appliedFilters.registrationYearMax = registrationYear[1];
  };

  render() {
    const { translationsStore, carsStore } = this.props;
    const { registrationYear } = this.state;

    return (
      <div className="registrationYear">
        <AirSlider
          label={translationsStore.translate('advancedfilter.registrationYear')}
          value={registrationYear || [carsStore.filters.registrationYearMin, carsStore.filtersregistrationYearMax]}
          disabled={carsStore.filters.registrationYearMin === carsStore.filters.registrationYearMax}
          min={carsStore.filters.registrationYearMin}
          max={carsStore.filters.registrationYearMax}
          range
          showLocale={false}
          onChange={this.changeRegistrationYear}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/GroupsManagerDashboard/CarAdvancedFilter/filters/RegistrationYearFilter/RegistrationYearFilter.js